import { observable, computed, action } from 'mobx';
import { persist } from 'mobx-persist';
import AlertModel from 'store/model/AlertModel';

class UiState {
  @persist
  @observable
  language = 'en';

  @observable pendingRequestCount = 0;

  @persist
  @observable
  groupId;

  @persist
  @observable
  sessionId;

  @persist
  @observable
  organisationName = '';

  @observable isMenuOpen = false;

  @observable alertModel;

  @computed
  get appIsInSync() {
    return this.pendingRequestCount === 0;
  }

  @action
  increasePendingRequest() {
    this.pendingRequestCount += 1;
  }

  @action
  decreasePendingRequest() {
    if (this.pendingRequestCount > 0) {
      this.pendingRequestCount -= 1;
    }
  }

  @action
  setAlertModel(alertModel) {
    this.alertModel = alertModel;
  }

  @action
  removeAlertModel() {
    this.alertModel = null;
  }

  showError(error) {
    this.createAlert({ title: 'Error', ok: 'OK', message: error.toString() });
  }

  createAlert({ title, message, ok, okHandler, cancel }) {
    const alertModel = new AlertModel(
      title,
      message,
      ok,
      () => {
        try {
          okHandler();
        } catch (error) {}
        this.removeAlertModel();
      },
      cancel,
      () => {
        this.removeAlertModel();
      }
    );
    this.setAlertModel(alertModel);
  }

  @action
  setOrganisationName(value) {
    this.organisationName = value;
  }

  @action
  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  @action
  hideMenu() {
    this.isMenuOpen = false;
  }
}

export default UiState;



// WEBPACK FOOTER //
// ./src/store/UiState.js